import { SummedMasterReport } from '../../../shared/domain/report/summed-master-report.model';

export class WinRateReportData{
  report: SummedMasterReport;
  winRate: number;
}
export class ByDayReport<T> {
  days: string[];
  data: T[];
}

export class ByDayReportData {
  days: {
    [key: string]: SummedMasterReport
  };

}

export class WidgetSizeByDayReportData extends ByDayReportData {
  salesRepresentative: string;
  publisherName: string;
  widgetSize: string;
}

export class UnitByDayReportData extends ByDayReportData {
  salesRepresentative: string;
  publisherName: string;
  bridgeAdUnitName: string;
  bridgeAdUnitId: any;
}


export const PRESET_REPORT_IDS = {
  unitReview: 'unit-review',
  impressionsByDay: 'impressions-review',
  dpUnitLandscape: 'dp-unit-landscape',
  winRate: 'win-rate',
  adopsTop25missingAdsTxt: 'invalid-adstxt',
  adopsVideoUnits: 'video-units',
  adopsReadyToActive: 'ready-to-active',
  adopsDemandPartnerInactivity: 'dp-inactivity',
  revopsNegativeProfitabilityUnits: 'negative-profitability-units',
  revopsNegativeMarginUnits: 'negative-margin-units',
  revopsBidderUnits: 'bidder-units',
  revopsEbdaUnits: 'ebda-units',
};

export const PRESET_REPORT_LABELS = {
  unitReview: 'Units by day',
  impressionsByDay: 'Impressions by day',
  dpUnitLandscape: 'DP unit landscape',
  winRate: 'Win rate',
  adopsReadyToActive: 'Ready to active',
  adopsVideoUnits: 'Video units',
  adopsTop25missingAdsTxt: 'Invalid ads.txt',
  adopsDemandPartnerInactivity: 'Demand partner inactivity',
  revopsNegativeProfitabilityUnits: 'Negative profitability units',
  revopsNegativeMarginUnits: 'Negative margin units',
  revopsBidderUnits: 'Bidder units',
  revopsEbdaUnits: 'EBDA units',
};
